import styled from "styled-components";
import { theme } from "../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";

export const Title = styled.h2.attrs(() => ({
    className: "l-delta-text",
}))`
    margin-bottom: 0;
`;

export const Description = styled.p.attrs(() => ({
    className: "l-base-text",
}))`
    margin-bottom: ${theme.space[3]}px;
    color: ${theme.colors.grey3};
`;

export const StartPrice = styled.p.attrs(() => ({
    className: "l-sub-micro-text",
}))`
    color: ${theme.colors.grey3};
`;
